import React from 'react';
import { Box, Typography } from '@mui/material';
import SectionContainer from './SectionContainer';
import SectionEyebrow from './SectionEyebrow';
import { serviceCategories } from './content';

const ServiceCategories = () => (
  <SectionContainer id="features" sx={{ py: { xs: 6, md: 10 } }}>
    <SectionEyebrow color="#F59E0B">Built For Every Service Business</SectionEyebrow>
    <Typography variant="h2" sx={{ fontWeight: 700, mb: 1.5, fontSize: { xs: 24, md: 32 }, maxWidth: 640 }}>
      One platform, every category of recurring service
    </Typography>
    <Typography sx={{ color: 'text.secondary', mb: 5, maxWidth: 560, fontSize: { xs: 14, md: 16 } }}>
      Whether it's a vehicle, an appliance, or a piece of equipment, Remembr adapts to how you work.
    </Typography>

    <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' }, gap: 3 }}>
      {serviceCategories.map(({ title, bullets, color, Icon }) => (
        <Box
          key={title}
          sx={(theme) => ({
            p: 3,
            borderRadius: 4,
            border: '1px solid',
            borderColor: theme.palette.mode === 'dark' ? 'rgba(255,255,255,0.08)' : 'rgba(15,23,42,0.06)',
            bgcolor: 'background.paper',
            transition: 'transform 0.25s ease, box-shadow 0.25s ease',
            '&:hover': {
              transform: 'translateY(-4px)',
              boxShadow: theme.palette.mode === 'dark' ? '0 20px 40px rgba(0,0,0,0.4)' : '0 20px 40px rgba(15,23,42,0.1)',
            },
          })}
        >
          <Box
            sx={{
              width: 52,
              height: 52,
              borderRadius: '14px',
              bgcolor: `${color}1A`,
              color,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <Icon />
          </Box>
          <Typography sx={{ fontWeight: 700, fontSize: 17, mb: 1 }}>{title}</Typography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.6 }}>
            {bullets.map((bullet) => (
              <Typography
                key={bullet}
                sx={{
                  color: 'text.secondary',
                  fontSize: 14,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  '&::before': { content: '""', width: 5, height: 5, borderRadius: '50%', bgcolor: color, flexShrink: 0 },
                }}
              >
                {bullet}
              </Typography>
            ))}
          </Box>
        </Box>
      ))}
    </Box>
  </SectionContainer>
);

export default ServiceCategories;
